import { useQuery } from '@apollo/client';
import {
  StaffEditContainerStaffUserFieldsFragment,
  StaffViewContainerStaffUserCurrentDocument,
  StaffViewContainerStaffUserCurrentFieldsFragment,
  StaffViewContainerStaffUserDocument
} from '../../../../generated';
import { useOid } from '../../../../hooks/useOid';
import { ComponentQueryLoader } from '../../../shared/component-query-loader';
import { getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled } from '../../../shared/utils/queryOptions';
import { StaffView } from './staff-view';

interface StaffViewContainerProps {
  staffUserId: string;
}

export const StaffViewContainer: React.FC<StaffViewContainerProps> = (props) => {
  const oid = useOid();
const staffUserCurrentQueryOptions = getStaffUserCurrentQueryOptionsWithOidAndCacheDisabled(oid);

  const { data, loading, error } = useQuery(StaffViewContainerStaffUserDocument, {
    variables: {
      staffUserId: props.staffUserId
    }
  });

  const {
    data: currentStaffData,
    loading: currentStaffLoading,
    error: currentStaffError
  } = useQuery(StaffViewContainerStaffUserCurrentDocument, staffUserCurrentQueryOptions);
  return (
    <ComponentQueryLoader
      error={error || currentStaffError}
      loading={loading || currentStaffLoading}
      hasData={data?.staffUser && currentStaffData?.staffUserCurrent}
      hasDataComponent={
        <StaffView
          currentStaffData={currentStaffData?.staffUserCurrent as StaffViewContainerStaffUserCurrentFieldsFragment}
          staffData={data?.staffUser as StaffEditContainerStaffUserFieldsFragment}
        />
      }
    />
  );
};
